import styled from "styled-components";

const Section = styled.section`
  background: white;
  width: 100%;
  padding: 20px 16px 0px 16px;

  h2 {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin: 0 auto;
  }

  strong {
    margin-bottom: 20px;
  }
`;

export { Section };
